import { render, staticRenderFns } from "./PatientTagBadges.vue?vue&type=template&id=6360b346"
import script from "./PatientTagBadges.vue?vue&type=script&lang=js"
export * from "./PatientTagBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports